import { getMbFromBytes } from './get-mb-from-bytes';

export const isAllowFileSize = (fileSize: number, maxSize: number) => {
  return getMbFromBytes(fileSize) < maxSize;
};
